<template>
  <div class="switch-container">
    <input class="switch-input" type="checkbox" readonly :checked="!isDark" @click="switchTheme">
    <div class="switch-button">
      <div class="switch-button-inside">
        <!-- <svg class="switch-icon off" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" />
        </svg> -->
        <!-- <svg class="switch-icon on" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="7" width="12" height="2" rx="1" />
        </svg> -->
        <svg class="switch-icon off" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
          <path
            d="M12 21q-3.775 0-6.388-2.613T3 12q0-3.45 2.25-5.988T11 3.05q.625-.075.975.45t-.025 1.1q-.425.65-.638 1.375T11.1 7.5q0 2.25 1.575 3.825T16.5 12.9q.775 0 1.538-.225t1.362-.625q.525-.35 1.075-.037t.475.987q-.35 3.45-2.937 5.725T12 21Z" />
        </svg>
        <svg class="switch-icon on" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
          <path
            d="M12 15q1.25 0 2.125-.875T15 12q0-1.25-.875-2.125T12 9q-1.25 0-2.125.875T9 12q0 1.25.875 2.125T12 15Zm0 2q-2.075 0-3.538-1.463T7 12q0-2.075 1.463-3.538T12 7q2.075 0 3.538 1.463T17 12q0 2.075-1.463 3.538T12 17ZM2 13q-.425 0-.713-.288T1 12q0-.425.288-.713T2 11h2q.425 0 .713.288T5 12q0 .425-.288.713T4 13H2Zm18 0q-.425 0-.713-.288T19 12q0-.425.288-.713T20 11h2q.425 0 .713.288T23 12q0 .425-.288.713T22 13h-2Zm-8-8q-.425 0-.713-.288T11 4V2q0-.425.288-.713T12 1q.425 0 .713.288T13 2v2q0 .425-.288.713T12 5Zm0 18q-.425 0-.713-.288T11 22v-2q0-.425.288-.713T12 19q.425 0 .713.288T13 20v2q0 .425-.288.713T12 23ZM5.65 7.05L4.575 6q-.3-.275-.288-.7t.288-.725q.3-.3.725-.3t.7.3L7.05 5.65q.275.3.275.7t-.275.7q-.275.3-.687.288T5.65 7.05ZM18 19.425l-1.05-1.075q-.275-.3-.275-.713t.275-.687q.275-.3.688-.287t.712.287L19.425 18q.3.275.288.7t-.288.725q-.3.3-.725.3t-.7-.3ZM16.95 7.05q-.3-.275-.288-.687t.288-.713L18 4.575q.275-.3.7-.288t.725.288q.3.3.3.725t-.3.7L18.35 7.05q-.3.275-.7.275t-.7-.275ZM4.575 19.425q-.3-.3-.3-.725t.3-.7l1.075-1.05q.3-.275.712-.275t.688.275q.3.275.288.688t-.288.712L6 19.425q-.275.3-.7.288t-.725-.288ZM12 12Z" />
        </svg>
      </div>
    </div>
  </div>
  <!-- <p>darkH: {{ darkH }} darkS: {{ darkS }} darkL: {{ darkL }}</p>
  <el-input v-model="darkH" type="range" max="256" min="0" />
  <el-input v-model="darkS" type="range" max="100" min="0" />
  <el-input v-model="darkL" type="range" max="100" min="0" /> -->
</template>

<script setup lang="ts">
const $colorMode = useColorMode()
const isDark = computed({
  get: () => $colorMode.value === 'dark',
  set: (val) => {
    console.log('isDark set to value:', val)
    switchTheme()
  },
})
function changeTheme(newTheme: string) {
  console.log('changeTheme to value:', newTheme)
  $colorMode.preference = newTheme
}
function switchTheme() {
  const newTheme = $colorMode.value === 'light' ? 'dark' : 'light'
  console.log('switchTheme, current theme:', $colorMode.value)
  changeTheme(newTheme)
}
const darkH = ref(168)
const darkS = ref(6)
const darkL = ref(13)
const darkSStr = computed(() => `${darkS.value}%`)
const darkLStr = computed(() => `${darkL.value}%`)
const themeColor = computed(() => $colorMode.value === 'light' ? '#fff' : '#000')
useHead({
  meta: [
    { name: 'theme-color', content: () => themeColor.value },
  ]
})
</script>

<style scoped lang="postcss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  --icon-size: 0.9em;
  --overall-height: .35em;
  --overall-width: 0.8em;
  /* --off-color: #704ccf; */
  /* --off-color: hsl(256, 58%, 55%); */
  --dark-h: v-bind(darkH);
  --dark-s: v-bind(darkSStr);
  --dark-l: v-bind(darkLStr);
  --dark-difference: 25%;
  --dark-lightnessPlus: calc(var(--dark-l) + var(--dark-difference));
  --dark-lightnessMinus: calc(var(--dark-l) - var(--dark-difference));
  --off-color: hsl(var(--dark-h), var(--dark-s), var(--dark-l));
  --dark-color-from: hsl(var(--dark-h), var(--dark-s), var(--dark-lightnessPlus));
  --dark-color-to: hsl(var(--dark-h), var(--dark-s), var(--dark-lightnessMinus));

  /* --on-color: #767c86; */
  --light-h: 208;
  --light-s: 13%;
  --light-l: 71%;
  --light-color: hsl(var(--light-h), var(--light-s), var(--light-l));
  --on-color: var(--light-color);
}

.switch-container {
  display: flex;
  justify-content: center;
  align-items: center;
  /* min-height: 100vh; */
  /* min-height: 100dvh; */
  padding: 1px;
  background-color: transparent;
  transition-property: background-color;
  transition-duration: .2s;
  position: relative;
  border-radius: 99px;
  /* box-shadow: 0 .125em .25em rgba(#000, .2); */
  /* transform: scale(0.8); */
  overflow: hidden;
  cursor: pointer;
}

.switch-input {
  -webkit-appearance: none;
  appearance: none;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.switch-button {
  display: inline-flex;
  padding: 0 .375em;
  border-radius: inherit;
  /* border: .0625em solid #6b717b; */
  background-color: hsl(var(--dark-h), var(--dark-s), 20%);
  box-shadow: inset 0 0 .5em rgba(#000, .4);
  transition-property: border-color, background-color;
  transition-duration: .2s;

  .switch-input:checked+& {
    border-color: transparent;
    background-color: hsl(var(--dark-h), var(--dark-s), 20%);
  }
}

.switch-button-inside {
  display: inline-flex;
  column-gap: var(--overall-width);
  position: relative;
  border-radius: inherit;
  padding: var(--overall-height);
  transform: translateX(-.375em);
  /* background-image: linear-gradient(90deg, hsl(var(--light-h), var(--light-s), 90%) 48%, hsl(var(--light-h), var(--light-s), 80%) 52%); */
  background-image: linear-gradient(90deg, var(--dark-color-from) 48%, var(--dark-color-to) 52%);
  box-shadow:
    inset .0625em 0 .0625em rgba(#fff, .4),
    inset -.0625em 0 .0625em rgba(#fff, .4);
  transition-property: transform;
  transition-duration: .2s;

  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    inset: 0;
    border-radius: inherit;
    /* background-image: linear-gradient(90deg, hsl(var(--light-h), var(--light-s), 40%) 48%, hsl(var(--light-h), var(--light-s), 60%) 52%); */
    background-image: linear-gradient(90deg, var(--dark-color-to) 48%, var(--dark-color-from) 52%);
    /* background-image: linear-gradient(90deg, var(--dark-color-from) 48%, var(--dark-color-to) 52%); */
    /* box-shadow:
      inset .0625em 0 .0625em rgba(#fff, .2),
      inset -.0625em 0 .0625em rgba(#fff, .2); */
    opacity: 0;
    transition-property: opacity;
    transition-duration: .2s;
  }

  .switch-input:checked+.switch-button>& {
    transform: translateX(.375em);

    &::after {
      opacity: 1;
    }
  }
}

.switch-icon {
  width: var(--icon-size);
  height: var(--icon-size);
  fill: var(--nord-yellow);
  filter:
    drop-shadow(0 .0625em .0625em rgba(#000, .4)) drop-shadow(0 0 .25em rgba(#fff, .9)) drop-shadow(0 0 .25em rgba(#fff, .4));
  transition-property: fill;
  transition-duration: .2s;

  &.off {
    .switch-input:checked+.switch-button & {
      fill: hsl(var(--dark-h), var(--dark-s), 35%);
      filter: none;
    }
  }

  &.on {
    .switch-input:not(:checked)+.switch-button & {
      fill: var(--on-color);
      filter: none;
    }

    .switch-input:checked+.switch-button & {
      fill: var(--sun-flower);
      /* fill: #fff; */
      /* filter: none; */
    }
  }
}
</style>
